import React, { Component } from "react";
import { decDaysToDate, formatDateToComputerDate } from "../../shared/utils";
import {
	getAllSales,
	handleChangeFilterStatements,
	openOrCloseExportFinishedModal,
	openOrCloseGeneralAlert,
	openOrCloseExportModal,
	exportIRPFToDownloadSales
} from "../../actions/sales";
import FilterAndExportBaseModal from "./template/FilterAndExportBaseModal";
import Loading from "../../../shared/Loading/Loading";
import MarketAnalysis from "../market-analysis/MarketAnalysis";
import Modal from "../../../shared/Modal/Modal";
import MySalesActions from "./template/MySalesActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Pagination from "../../../shared/Pagination/Pagination";
import ListFidelityPlan from "./template/list-fidelity-plan/ListFidelityPlan";
import SalesListHeader from "./template/sales-list-header/SalesListHeader";
import SalesFilterTag from "./template/filter-tags/SalesFilterTag";
import SalesFilterListTags from "./template/filter-tags/SalesFilterListTags";
import DatePeriodFilter from "./template/filter/DatePeriodFilter";
import Alert from "../../../shared/Alert";

export class MySales extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalIsOpen: false,
			currentPage: 1,
			isDownload: false
		};

		this.closeExportFinishedModal = this.closeExportFinishedModal.bind(this);
		this.closeGeneralAlert = this.closeGeneralAlert.bind(this);
	}

	closeExportFinishedModal() {
		this.props.openOrCloseExportFinishedModal(false);
	}

	closeGeneralAlert() {
		this.props.openOrCloseGeneralAlert(false);
	}

	handleChangePage = nextPage => {
		this.props.handleChangeFilterStatements(
			this.props.filteredStatements,
			{ numPag: nextPage },
			true
		);
	};

	componentWillMount() {
		this.props.handleChangeFilterStatements(this.props.filteredStatements, {
			periodType: 0,
			status: 0,
			start: formatDateToComputerDate(decDaysToDate(new Date(), 365)),
			end: formatDateToComputerDate(new Date())
		});
		this.props.getAllSales({
			start: formatDateToComputerDate(decDaysToDate(new Date(), 365)),
			end: formatDateToComputerDate(new Date()),
			periodType: 0,
			numPag: 1,
			salesPerPage: 20
		});
	}

	isDownloadFn = data => {
		this.setState({
			isDownload: data
		});
	};

	downloadIRPFFn = (ev, type = "xlsx") => {
		this.props.exportIRPFToDownloadSales(type);
	};

	render() {
		return (
			<div className="my-sales">
				<div className="panel-component my-sales-content">
					<SalesListHeader
						activeStatus={this.props.filteredStatements.status}
						toReceive={this.props.salesData.totalToRecive}
						received={this.props.salesData.totalRecived}
						soldMiles={this.props.salesData.totalMiles}
						openExport={this.props.openOrCloseExportModal}
						isFetching={this.props.isFetching}
						downloadIRPF={this.downloadIRPFFn}
					/>
					<MySalesActions />
					<SalesFilterListTags />
					{!this.props.isFetching &&
						!this.props.searchIsFetching &&
						!this.props.searchNotFound &&
						!this.props.findSalesHasError &&
						this.props.salesData.sales.length > 0 && (
							<div>
								<ListFidelityPlan />
								<Pagination
									currentPage={this.props.filteredStatements.numPag}
									totalRegisters={this.props.salesData.countSeles}
									registersPerPage={this.props.filteredStatements.salesPerPage}
									maxPageSelectorToShow={4}
									handleChangePage={this.handleChangePage}
								/>
							</div>
						)}
					{(this.props.isFetching ||
						this.props.searchIsFetching ||
						this.props.searchNotFound ||
						this.props.findSalesHasError) && (
						<div className="my-sales-not-found">
							{!this.props.isFetching &&
								!this.props.searchIsFetching &&
								!this.props.findSalesHasError && (
									<span>
										<div className="my-sales-not-found__img-not-found" />
										<h5>Sem vendas para serem exibidas aqui por enquanto!</h5>
									</span>
								)}
							{(this.props.isFetching || this.props.searchIsFetching) && <Loading />}
							{this.props.findSalesHasError && (
								<div className="my-sales-has-error">
									<img className="my-sales-has-error--image" />
									<h4>Ixi! Ocorreu um erro ao buscar suas milhas :(</h4>
									<h6>Por favor, tente novamente mais tarde!</h6>
								</div>
							)}
						</div>
					)}

					{/* Filter modal */}
					{(this.props.modalFilterIsOpen || this.props.modalExportIsOpen) && (
						<FilterAndExportBaseModal
							isFilter={this.props.modalFilterIsOpen}
							isExport={this.props.modalExportIsOpen}
							isDownload={this.isDownloadFn}
						/>
					)}

					{/* Aviso de exportacao realizada com sucesso */}
					{this.props.isExportFinished &&
						!this.state.isDownload && (
							<Modal
								title="Exportação em andamento"
								description="Você receberá os dados no e-mail cadastrado em até 24h."
								confirm="Ok, entendi."
								show={true}
								fixed={true}
								onCancel={this.closeExportFinishedModal}
								onConfirm={this.closeExportFinishedModal}
							/>
						)}
					{this.props.generalAlertOpen && (
						<Modal
							title="Comunicado"
							description={this.props.generalAlertMsg}
							confirm="Ok, entendi."
							show={true}
							fixed={true}
							onCancel={this.closeGeneralAlert}
							onConfirm={this.closeGeneralAlert}
						/>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	salesData: state.mySales.salesData,
	filteredStatements: state.mySales.filteredStatements,
	isFetching: state.mySales.isFetching,
	searchIsFetching: state.mySales.searchIsFetching,
	modalFilterIsOpen: state.mySales.modalFilterIsOpen,
	modalExportIsOpen: state.mySales.modalExportIsOpen,
	isExportFinished: state.mySales.isExportFinished,
	searchNotFound: state.mySales.searchNotFound,
	findSalesHasError: state.mySales.findSalesHasError,
	generalAlertOpen: state.mySales.generalAlertOpen,
	generalAlertMsg: state.mySales.generalAlertMsg,
	suspendedCount: state.mySales.salesData.suspendedCount,
});

const mapDispatchToProps = dispacth =>
	bindActionCreators(
		{
			getAllSales,
			handleChangeFilterStatements,
			openOrCloseExportFinishedModal,
			openOrCloseGeneralAlert,
			openOrCloseExportModal,
			exportIRPFToDownloadSales
		},
		dispacth
	);
export default connect(mapStateToProps, mapDispatchToProps)(MySales);
